<script setup lang="ts">
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { defaultGraphQLClient } from '@/composables/default-urql-client'
import { TPPServer } from '@/modules/tpp/types'
import gql from 'graphql-tag'
import { ref, watch } from 'vue'
import { Loader } from 'lucide-vue-next'

const props = defineProps<{
    active: boolean
}>()
const loading = ref(false)
const servers = ref<TPPServer[]>([])

watch(
    () => props.active,
    async () => {
        if (props.active) {
            await init()
        }
    }
)

async function init() {
    try {
        loading.value = true
        const { data } = await defaultGraphQLClient.query(
            gql`
                query {
                    tppServers {
                        uuid
                        title
                    }
                }
            `,
            {}
        )

        if (data) {
            servers.value = data.tppServers
        }
    } finally {
        loading.value = false
    }
}
</script>

<template>
    <AccordionItem value="tpp" class="border-b-0">
        <AccordionTrigger
            class="py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
        >
            <div class="flex items-center">
                <div class="w-6">
                    <FontAwesomeIcon :icon="['fal', 'shield-alt']" class="size-4!" />
                </div>
                <div class="ml-3 text-xs">TPP</div>
            </div>
        </AccordionTrigger>
        <AccordionContent class="pb-0 text-xs text-white">
            <div v-if="loading" class="flex items-center space-x-2 pl-[52px] py-2">
                <Loader class="mr-2 h-4 w-4 shrink-0 opacity-50 animate-spin" />
                <span>Loading...</span>
            </div>
            <div v-else class="flex flex-col">
                <template v-for="server in servers" :key="server.id">
                    <RouterLink
                        :to="{
                            name: 'tpp.server.domains.index',
                            params: {
                                serverId: server.uuid,
                            },
                            query: {
                                sort: JSON.stringify([
                                    {
                                        column: 'expiry_date',
                                        direction: 'asc',
                                    },
                                ]),
                            },
                        }"
                        class="pl-[52px] py-2 pr-4 hover:bg-neutral-600/50 truncate"
                        >{{ server.title }}</RouterLink
                    >
                </template>
            </div>
        </AccordionContent>
    </AccordionItem>
</template>

<style scoped>
.router-link-exact-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
